import * as React from 'react';
import { ModalWindowHeader } from './ModalWindowHeader';
import {
  ModalWindowCard,
  ModalWindowCardContent,
  ModalWindowContainer,
  ModalWindowSubstrate,
  SizingDiv,
  StyledCard,
} from './ModalWindowV1';
import { ModalWindowFooter } from './ModalWindowFooter';
import { ModalWindowTitle } from './ModalWindowTitle';
import { TextAlign } from '../../theming/types/TextAlign';
import { JustifyContent } from '../../theming/types/JustifyContent';

export type ModalWindowTypes = 'fit' | 'small' | 'medium';

export type ModalWindowMode = 'default' | 'transition';

export interface IModalWindowProps {
  /** @Deprecated Additional CSS class. SpruceTheme V1 Only */
  className?: string;
  /** @Deprecated Set the content justification of underlying content. SpruceTheme V1 Only */
  contentJustifyContent?: JustifyContent;
  /** @Deprecated Set the alignment of underlying content*/
  contentTextAlign?: TextAlign;
  footer?: React.ReactNode;
  header?: React.ReactNode;
  height?: number | string;
  minHeight?: string | number;
  /**
   * @Deprecated("Use should")
   * Different mode of modal. */
  mode?: ModalWindowMode;
  /** A title to display next to the Close (X) button */
  title?: React.ReactNode;
  /** Different visual type of modal.  */
  uitype?: ModalWindowTypes;
  /** Set the width of the ModalWindow (Overrides uitype) */
  width?: string | number;
  /** @Deprecated React CSS Properties. SpruceTheme V1 Only */
  style?: React.CSSProperties;
  /** A callback triggered when user clicked "close" button. */
  onClose?: () => void;
  children?: React.ReactNode;
}

/**
 * A wrapper component positioned over everything else in the document.
 * The content is also wrapped around {@link Card} component.
 */
export const ModalWindow: React.FC<IModalWindowProps> = ({
  children,
  className,
  contentJustifyContent,
  contentTextAlign,
  footer,
  header,
  height,
  minHeight,
  mode,
  onClose,
  style,
  title,
  uitype,
  width,
}) => {
  const closeIfNotTransitionMode = (e: React.MouseEvent<any>) => {
    if (mode !== 'transition' && onClose) {
      e.stopPropagation();
      onClose();
    }
  };
  return (
    <ModalWindowContainer className={className} style={style}>
      <ModalWindowSubstrate onClick={closeIfNotTransitionMode} />
      <SizingDiv height={height} minHeight={minHeight} width={width}>
        <StyledCard>
          <ModalWindowCard size={!height && !minHeight && !width ? uitype : 'fit'}>
            <ModalWindowTitle mode={mode || 'default'} title={title} onClose={closeIfNotTransitionMode} />
            <ModalWindowHeader>{header}</ModalWindowHeader>
            <ModalWindowCardContent justifyContent={contentJustifyContent} textAlign={contentTextAlign}>
              {children}
            </ModalWindowCardContent>
            <ModalWindowFooter>{footer}</ModalWindowFooter>
          </ModalWindowCard>
        </StyledCard>
      </SizingDiv>
    </ModalWindowContainer>
  );
};
